module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('select', {
    staticClass: "klickart-select"
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.go_to_next')))]), _vm._v(" "), _vm._l((_vm.stepInactiveList), function(step) {
    return _c('option', {
      domProps: {
        "value": step.id,
        "selected": step.id === _vm.selected
      }
    }, [_vm._v(_vm._s(((_vm.stepDisplayPosition(step)) + " - " + (step.sanitized_title))))])
  })], 2)
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-54578204!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/general/StepJumpSelect.vue
 ** module id = 831
 ** module chunks = 1
 **/